(function () {
  var root = document.querySelector("[data-product-hero]");

  if (!root) {
    return;
  }

  var mainEl = root.querySelector("[data-product-main]");
  var thumbsEl = root.querySelector("[data-product-thumbs]");
  var qtyEl = root.querySelector("[data-qty-value]");
  var minusBtn = root.querySelector("[data-qty-minus]");
  var plusBtn = root.querySelector("[data-qty-plus]");
  var cartBtn = root.querySelector("[data-cart-btn]");
  var detailsList = root.querySelector("[data-product-details]");
  var moneyFormat = root.getAttribute("data-money-format") || "{{amount}}";
  var radioOn = root.getAttribute("data-radio-on") || "";
  var radioOff = root.getAttribute("data-radio-off") || "";
  var onetimeButton = root.querySelector('[data-product-purchase="onetime"]');
  var subscribeWrap = root.querySelector('[data-product-purchase-wrap="subscribe"]');
  var subscribeButton = root.querySelector('[data-product-purchase="subscribe"]');
  var supplyButtons = Array.from(root.querySelectorAll("[data-product-supply]"));
  var onetimePriceEl = root.querySelector("[data-product-onetime-price]");
  var subscribeCurrentEl = root.querySelector("[data-product-sub-current]");
  var subscribeUnitEl = root.querySelector("[data-product-sub-unit]");
  var subscribeSortLabel = root.querySelector("[data-product-subscribe-sort-label]");
  var subscribePlanLabel = root.querySelector("[data-product-subscribe-plan-label]");
  var variantsDataEl = root.querySelector("[data-product-variants]");
  var proteinDatesTextEl = root.querySelector("[data-protein-dates-text]");
  var proteinDatesHighlightEl = root.querySelector("[data-protein-dates-highlight]");
  var subscribeSortIcons = {
    chevron: root.getAttribute("data-subscribe-chevron") || "",
    close: root.getAttribute("data-subscribe-close") || "",
  };
  var sectionId = root.getAttribute("data-section-id") || "";
  var planNameMap = {};
  var variants = [];
  var purchaseType = root.getAttribute("data-default-purchase-type") || "onetime";
  var selectionMode = purchaseType === "subscribe" && subscribeWrap ? "subscribe" : "onetime";

  var state = {
    variantId: root.getAttribute("data-variant-id") || "",
    priceCents: parseInt(root.getAttribute("data-price-cents"), 10) || 0,
    subscriptionPrice: Number(root.getAttribute("data-subscription-price") || 0),
    sellingPlanId: root.getAttribute("data-selling-plan-id") || "",
    qty: 1,
    available: root.getAttribute("data-available") === "true",
    boxCount: Number(root.getAttribute("data-box-count") || 1) || 1,
  };

  if (variantsDataEl) {
    try {
      variants = JSON.parse(variantsDataEl.textContent || "[]");
      variants.forEach(function (variant) {
        (variant.selling_plans || []).forEach(function (plan) {
          if (plan && plan.id && plan.name) {
            planNameMap[String(plan.id)] = plan.name;
          }
        });
      });
    } catch (error) {
      variants = [];
    }
  }

  function formatMoney(cents) {
    var value = Number(cents) || 0;

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(value, moneyFormat);
    }

    var amount = (value / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(value / 100));
    var amountWithComma = amount.replace(".", ",");
    var amountNoDecimalsWithComma = amountNoDecimals;
    var format = moneyFormat || "{{amount}}";

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function shopifyRoot() {
    return window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
  }

  function normalizePlanLabel(name) {
    var label = String(name || "").trim();
    var lower = label.toLowerCase();

    if (lower.indexOf("year") !== -1 || lower.indexOf("annual") !== -1) {
      return "Yearly";
    }

    if (lower.indexOf("month") !== -1) {
      return "Monthly";
    }

    if (lower.indexOf("week") !== -1) {
      return "Weekly";
    }

    return label;
  }

  function buildPlanNameMap(productData) {
    var map = {};

    (productData.selling_plan_groups || []).forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) {
        map[String(plan.id)] = plan.name;
      });
    });

    return map;
  }

  function resolvePlanName(map, planId, fallbackName) {
    if (fallbackName) {
      return fallbackName;
    }

    if (planId && map) {
      return map[String(planId)] || "";
    }

    return "";
  }

  function buildPlanEntry(planId, planName, price, discount) {
    var label = normalizePlanLabel(planName);

    return {
      id: planId,
      name: planName || label || "Monthly",
      label: label || "Monthly",
      price: price,
      discount: Number(discount || 0),
    };
  }

  function getPlanDiscountFromAllocation(allocation, variantPrice) {
    var discount = 0;

    if (!allocation) {
      return discount;
    }

    if (allocation.selling_plan && allocation.selling_plan.price_adjustments) {
      allocation.selling_plan.price_adjustments.forEach(function (adjustment) {
        if (adjustment.value_type === "percentage" && !discount) {
          discount = Number(adjustment.value || 0);
        }
      });
    }

    if (!discount && variantPrice > allocation.price) {
      discount = Math.round(((variantPrice - allocation.price) * 100) / variantPrice);
    }

    return discount;
  }

  function getVariantById(variantId) {
    return variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getActiveVariant() {
    return getVariantById(state.variantId) || variants[0];
  }

  function getActiveBoxCount() {
    var activeSupply = supplyButtons.find(function (button) {
      return String(button.getAttribute("data-variant-id")) === String(state.variantId);
    });

    if (activeSupply) {
      return Number(activeSupply.getAttribute("data-box-count") || 1) || 1;
    }

    var activeVariant = getActiveVariant();
    if (activeVariant && activeVariant.box_count) {
      return Number(activeVariant.box_count) || 1;
    }

    return Number(state.boxCount || 1) || 1;
  }

  function formatUnitPrice(cents) {
    return formatMoney(cents) + "/tube";
  }

  function getSelectableOptions() {
    var options = [];

    if (subscribeWrap) {
      options.push(subscribeWrap);
    }

    if (onetimeButton) {
      options.push(onetimeButton);
    }

    return options;
  }

  function setActiveChoice(buttons, activeElement) {
    buttons.forEach(function (button) {
      var isActive = button === activeElement;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function setActiveSupplyById(variantId) {
    var match = supplyButtons.find(function (button) {
      return String(button.getAttribute("data-variant-id")) === String(variantId);
    });

    if (match) {
      setActiveChoice(supplyButtons, match);
      state.boxCount = Number(match.getAttribute("data-box-count") || 1) || 1;
      state.available = match.getAttribute("data-available") !== "false";
    }
  }

  function setActiveOption(activeElement) {
    getSelectableOptions().forEach(function (option) {
      var isActive = option === activeElement;
      option.classList.toggle("is-active", isActive);

      if (option === subscribeWrap) {
        if (subscribeButton) {
          subscribeButton.setAttribute("aria-pressed", isActive ? "true" : "false");
        }
      } else {
        option.setAttribute("aria-pressed", isActive ? "true" : "false");
      }

      var icon = option.querySelector(".product-hero__purchase-radio");

      if (icon && radioOn && radioOff) {
        icon.src = isActive ? radioOn : radioOff;
      }
    });
  }

  function getPlansForVariant(variant) {
    if (!variant) {
      return [];
    }

    if (variant.selling_plans && variant.selling_plans.length) {
      return variant.selling_plans;
    }

    if (variant.selling_plan_id) {
      var planName = resolvePlanName(planNameMap, variant.selling_plan_id, variant.selling_plan_name);
      var matchedPlan = (variant.selling_plans || []).find(function (plan) {
        return String(plan.id) === String(variant.selling_plan_id);
      });
      var planPrice = matchedPlan
        ? matchedPlan.price
        : variant.subscription_price || variant.price;
      var planDiscount = matchedPlan ? matchedPlan.discount : 0;

      if (!planDiscount && variant.price > planPrice) {
        planDiscount = Math.round(((variant.price - planPrice) * 100) / variant.price);
      }

      return [buildPlanEntry(variant.selling_plan_id, planName, planPrice, planDiscount)];
    }

    return [];
  }

  function updateSubscribeHeadPrices() {
    var activeVariant = getActiveVariant();

    if (!activeVariant) {
      return;
    }

    var comparePrice = Number(activeVariant.price || 0);
    var subPrice = state.subscriptionPrice || Number(activeVariant.subscription_price || comparePrice);
    var boxCount = getActiveBoxCount();
    var unitPrice = boxCount > 0 ? Math.round(subPrice / boxCount) : subPrice;

    if (subscribeCurrentEl) {
      subscribeCurrentEl.textContent = formatMoney(subPrice);
    }

    if (subscribeUnitEl) {
      subscribeUnitEl.textContent = "(" + formatUnitPrice(unitPrice) + ")";
      subscribeUnitEl.hidden = !subPrice;
    }
  }

  function updateSubscribeDiscountDisplay(discount) {
    var discountValue = Number(discount || 0);
    var benefitItem = root.querySelector("[data-product-sub-benefit-discount-item]");
    var benefitEl = root.querySelector("[data-product-sub-benefit-discount]");
    var badgeEl = root.querySelector("[data-product-sub-badge]");

    if (benefitEl) {
      benefitEl.textContent =
        discountValue > 0 ? "Save " + discountValue + "% every order" : "";
    }

    if (benefitItem) {
      benefitItem.hidden = discountValue <= 0;
    }

    if (badgeEl) {
      badgeEl.textContent = discountValue > 0 ? discountValue + "% OFF" : "";
      badgeEl.hidden = discountValue <= 0;
    }
  }

  function updateOptionPrices() {
    var activeVariant = getActiveVariant();
    var boxCount = getActiveBoxCount();

    if (activeVariant && onetimePriceEl) {
      var onetimeUnit =
        boxCount > 0
          ? Math.round(Number(activeVariant.price || 0) / boxCount)
          : Number(activeVariant.price || 0);
      onetimePriceEl.textContent = formatUnitPrice(onetimeUnit);
    }

    updateSubscribeHeadPrices();
  }

  function updateCartPrice() {
    if (!cartBtn) {
      return;
    }

    var qty = parseInt(qtyEl && qtyEl.textContent, 10) || state.qty || 1;
    var unitPrice = state.priceCents;

    if (selectionMode === "subscribe") {
      unitPrice = state.subscriptionPrice || state.priceCents;
    }

    var total = unitPrice * qty;
    var prefix = cartBtn.getAttribute("data-cta-prefix") || "Add to Cart —";

    if (!state.available) {
      cartBtn.textContent = "Sold out " + formatMoney(unitPrice);
      return;
    }

    cartBtn.textContent = prefix + " " + formatMoney(total);
  }

  // Variant metafield custom.number_of_protein_dates_in_tubes for the active variant.
  // Prefers the embedded variants JSON, falls back to data-protein-dates on the supply button.
  function getActiveProteinDates() {
    var activeVariant = getVariantById(state.variantId);

    if (activeVariant && activeVariant.protein_dates != null && activeVariant.protein_dates !== "") {
      return Number(activeVariant.protein_dates) || 0;
    }

    var activeSupply = supplyButtons.find(function (button) {
      return String(button.getAttribute("data-variant-id")) === String(state.variantId);
    });

    if (activeSupply && activeSupply.hasAttribute("data-protein-dates")) {
      return Number(activeSupply.getAttribute("data-protein-dates")) || 0;
    }

    return 0;
  }

  function updateProteinDatesHighlight() {
    if (!proteinDatesTextEl || !supplyButtons.length) {
      return;
    }

    var count = getActiveProteinDates();

    proteinDatesTextEl.textContent = count ? count + " protein dates" : "";

    if (proteinDatesHighlightEl) {
      proteinDatesHighlightEl.hidden = !count;
    }
  }

  function updateQtyLock() {
    if (plusBtn) {
      plusBtn.disabled = false;
    }

    if (minusBtn) {
      minusBtn.disabled = state.qty <= 1;
    }
  }

  function selectPlan(plan) {
    if (!plan) {
      return;
    }

    state.sellingPlanId = String(plan.id);
    state.subscriptionPrice = Number(plan.price || 0);

    updateSubscribeHeadPrices();
    updateSubscribeDiscountDisplay(plan.discount);

    root.querySelectorAll("[data-product-subscribe-sort-option]").forEach(function (button) {
      var isActive = String(button.getAttribute("data-plan-id")) === String(plan.id);
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    if (subscribeSortLabel) {
      subscribeSortLabel.textContent = plan.label || plan.name || "Monthly";
    }

    if (subscribePlanLabel) {
      subscribePlanLabel.textContent = plan.label || plan.name || "Monthly";
    }

    updateCartPrice();
  }

  function closeSubscribeSort(sortRoot) {
    if (!sortRoot) {
      return;
    }

    var toggle = sortRoot.querySelector("[data-product-subscribe-sort-toggle]");
    var dropdown = sortRoot.querySelector("[data-product-subscribe-sort-dropdown]");
    var overlay = sortRoot.querySelector("[data-product-subscribe-sort-overlay]");

    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
    }

    if (dropdown) {
      dropdown.classList.remove("is-open");
      dropdown.setAttribute("aria-hidden", "true");
    }

    if (overlay) {
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-hidden", "true");
    }

    sortRoot.classList.remove("is-open");
  }

  function openSubscribeSort(sortRoot) {
    if (!sortRoot) {
      return;
    }

    var toggle = sortRoot.querySelector("[data-product-subscribe-sort-toggle]");
    var dropdown = sortRoot.querySelector("[data-product-subscribe-sort-dropdown]");
    var overlay = sortRoot.querySelector("[data-product-subscribe-sort-overlay]");

    if (toggle) {
      toggle.setAttribute("aria-expanded", "true");
    }

    if (dropdown) {
      dropdown.classList.add("is-open");
      dropdown.setAttribute("aria-hidden", "false");
    }

    if (overlay) {
      overlay.classList.add("is-open");
      overlay.setAttribute("aria-hidden", "false");
    }

    sortRoot.classList.add("is-open");
  }

  function buildSubscribeSortHtml(plans) {
    var optionsHtml = plans
      .map(function (plan, index) {
        var planLabel = plan.label || normalizePlanLabel(plan.name) || "Monthly";
        var activeClass = index === 0 ? " is-active" : "";
        var selected = index === 0 ? "true" : "false";

        return (
          '<button type="button" class="product-hero__subscribe-sort-option' +
          activeClass +
          '" role="option" aria-selected="' +
          selected +
          '" data-product-subscribe-sort-option data-plan-id="' +
          String(plan.id) +
          '" data-plan-price="' +
          String(plan.price) +
          '" data-plan-label="' +
          planLabel +
          '" data-plan-discount="' +
          String(plan.discount || 0) +
          '">' +
          '<span class="product-hero__subscribe-sort-option-content"><span>' +
          planLabel +
          "</span></span></button>"
        );
      })
      .join("");

    var firstLabel = plans[0].label || normalizePlanLabel(plans[0].name) || "Monthly";

    return (
      '<div class="product-hero__subscribe-sort" data-product-subscribe-sort>' +
      '<div class="product-hero__subscribe-sort-control">' +
      '<button type="button" class="product-hero__subscribe-sort-trigger" aria-expanded="false" aria-haspopup="listbox" aria-controls="product-subscribe-sort-dropdown-' +
      sectionId +
      '" data-product-subscribe-sort-toggle>' +
      '<span class="product-hero__subscribe-sort-value" data-product-subscribe-sort-label>' +
      firstLabel +
      "</span>" +
      (subscribeSortIcons.chevron
        ? '<img class="product-hero__subscribe-sort-icon" src="' +
          subscribeSortIcons.chevron +
          '" alt="" width="10" height="6" loading="lazy">'
        : "") +
      "</button>" +
      '<div id="product-subscribe-sort-dropdown-' +
      sectionId +
      '" class="product-hero__subscribe-sort-dropdown" data-product-subscribe-sort-dropdown role="listbox" aria-label="Delivery frequency" aria-hidden="true">' +
      '<div class="product-hero__subscribe-sort-dropdown-head">' +
      '<p class="product-hero__subscribe-sort-dropdown-title">Delivery</p>' +
      '<button type="button" class="product-hero__subscribe-sort-dropdown-close" aria-label="Close delivery options" data-product-subscribe-sort-close>' +
      (subscribeSortIcons.close
        ? '<img src="' + subscribeSortIcons.close + '" alt="" width="20" height="20" loading="lazy">'
        : "") +
      "</button></div>" +
      '<div class="product-hero__subscribe-sort-options">' +
      optionsHtml +
      "</div></div></div>" +
      '<button type="button" class="product-hero__subscribe-sort-overlay" aria-label="Close delivery options" data-product-subscribe-sort-overlay aria-hidden="true"></button>' +
      "</div>"
    );
  }

  function initSubscribeSort() {
    var sort = root.querySelector("[data-product-subscribe-sort]");

    if (!sort) {
      return;
    }

    var toggle = sort.querySelector("[data-product-subscribe-sort-toggle]");
    var closeBtn = sort.querySelector("[data-product-subscribe-sort-close]");
    var overlay = sort.querySelector("[data-product-subscribe-sort-overlay]");
    var options = Array.from(sort.querySelectorAll("[data-product-subscribe-sort-option]"));

    if (toggle) {
      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var dropdown = sort.querySelector("[data-product-subscribe-sort-dropdown]");
        if (dropdown && dropdown.classList.contains("is-open")) {
          closeSubscribeSort(sort);
        } else {
          openSubscribeSort(sort);
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeSubscribeSort(sort);
      });
    }

    if (overlay) {
      overlay.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeSubscribeSort(sort);
      });
    }

    options.forEach(function (option) {
      option.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectPlan({
          id: option.getAttribute("data-plan-id"),
          price: option.getAttribute("data-plan-price"),
          label: option.getAttribute("data-plan-label"),
          name: option.getAttribute("data-plan-label"),
          discount: option.getAttribute("data-plan-discount"),
        });
        closeSubscribeSort(sort);
      });
    });

    if (!root.dataset.subscribeSortBound) {
      root.dataset.subscribeSortBound = "true";

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }

        var currentSort = root.querySelector("[data-product-subscribe-sort]");
        var currentDropdown = currentSort
          ? currentSort.querySelector("[data-product-subscribe-sort-dropdown]")
          : null;

        if (currentDropdown && currentDropdown.classList.contains("is-open")) {
          closeSubscribeSort(currentSort);
        }
      });

      document.addEventListener("click", function (event) {
        var currentSort = root.querySelector("[data-product-subscribe-sort]");
        var currentDropdown = currentSort
          ? currentSort.querySelector("[data-product-subscribe-sort-dropdown]")
          : null;

        if (!currentDropdown || !currentDropdown.classList.contains("is-open")) {
          return;
        }

        if (window.matchMedia("(max-width: 768px)").matches) {
          return;
        }

        if (currentSort.contains(event.target)) {
          return;
        }

        closeSubscribeSort(currentSort);
      });
    }
  }

  function renderSubscribePlans(variant) {
    var plans = getPlansForVariant(variant);
    var plansWrap = subscribeWrap
      ? subscribeWrap.querySelector("[data-product-subscribe-plans-wrap]")
      : null;

    if (!plansWrap) {
      return;
    }

    subscribeSortLabel = null;
    subscribePlanLabel = null;

    if (!plans.length) {
      if (!plansWrap.querySelector("[data-product-subscribe-sort], [data-product-subscribe-plan-label]")) {
        plansWrap.innerHTML = "";
      }

      return;
    }

    if (plans.length > 1) {
      plansWrap.innerHTML = buildSubscribeSortHtml(plans);
      subscribeSortLabel = plansWrap.querySelector("[data-product-subscribe-sort-label]");
      initSubscribeSort();
      var matchedPlan = plans.find(function (plan) {
        return String(plan.id) === String(state.sellingPlanId);
      });
      selectPlan(matchedPlan || plans[0]);
      return;
    }

    plansWrap.innerHTML =
      '<p class="product-hero__subscribe-plan-label" data-product-subscribe-plan-label></p>';
    subscribePlanLabel = plansWrap.querySelector("[data-product-subscribe-plan-label]");
    selectPlan(plans[0]);
  }

  function applySupplyVariant(variantId) {
    var variant = getVariantById(variantId);

    if (!variant && supplyButtons.length) {
      var fallbackButton = supplyButtons.find(function (button) {
        return String(button.getAttribute("data-variant-id")) === String(variantId);
      });

      if (fallbackButton) {
        state.variantId = String(variantId);
        state.priceCents = Number(fallbackButton.getAttribute("data-price") || 0);
        state.available = fallbackButton.getAttribute("data-available") !== "false";
        state.boxCount = Number(fallbackButton.getAttribute("data-box-count") || 1) || 1;
        setActiveSupplyById(variantId);
        updateOptionPrices();
        updateCartPrice();
        updateProteinDatesHighlight();
        return;
      }
    }

    if (!variant) {
      return;
    }

    state.variantId = String(variant.id);
    state.priceCents = Number(variant.price || 0);
    state.available = Boolean(variant.available);
    state.boxCount = Number(variant.box_count || 1) || 1;
    setActiveSupplyById(variant.id);

    if (selectionMode === "subscribe") {
      renderSubscribePlans(variant);
    } else {
      state.subscriptionPrice = Number(variant.subscription_price || variant.price || 0);
    }

    updateOptionPrices();
    updateCartPrice();
    updateProteinDatesHighlight();
  }

  function applyPurchaseMode(mode) {
    var activeVariant = getActiveVariant();

    selectionMode = mode;

    if (!activeVariant) {
      updateCartPrice();
      return;
    }

    state.variantId = String(activeVariant.id);
    state.priceCents = Number(activeVariant.price || 0);
    state.available = Boolean(activeVariant.available);

    if (mode === "subscribe") {
      var plans = getPlansForVariant(activeVariant);

      if (plans.length) {
        var selectedPlan = plans.find(function (plan) {
          return String(plan.id) === String(state.sellingPlanId);
        });
        selectPlan(selectedPlan || plans[0]);
      } else {
        state.subscriptionPrice = Number(activeVariant.subscription_price || activeVariant.price || 0);
        state.sellingPlanId = activeVariant.selling_plan_id
          ? String(activeVariant.selling_plan_id)
          : "";
        updateSubscribeHeadPrices();
      }

      renderSubscribePlans(activeVariant);
    } else {
      updateOptionPrices();
    }

    updateCartPrice();
  }

  function hydrateFromProductJson() {
    var handle = root.getAttribute("data-product-handle");

    if (!handle || !variantsDataEl) {
      return Promise.resolve();
    }

    return fetch(shopifyRoot() + "products/" + encodeURIComponent(handle) + ".js")
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Product fetch failed");
        }

        return response.json();
      })
      .then(function (productData) {
        planNameMap = buildPlanNameMap(productData);

        variants = (productData.variants || []).map(function (variant) {
          var existing = getVariantById(variant.id) || {};
          var allocations = variant.selling_plan_allocations || [];
          var sellingPlans = allocations.map(function (allocation) {
            var planName = resolvePlanName(
              planNameMap,
              allocation.selling_plan_id,
              allocation.selling_plan ? allocation.selling_plan.name : ""
            );

            return buildPlanEntry(
              allocation.selling_plan_id,
              planName,
              allocation.price,
              getPlanDiscountFromAllocation(allocation, variant.price)
            );
          });

          if (!sellingPlans.length && productData.selling_plan_groups) {
            productData.selling_plan_groups.forEach(function (group) {
              (group.selling_plans || []).forEach(function (plan) {
                sellingPlans.push(buildPlanEntry(plan.id, plan.name, variant.price, 0));
              });
            });
          }

          var firstAllocation = allocations[0] || null;
          var firstPlan = sellingPlans[0] || null;

          return {
            id: variant.id,
            title: variant.title,
            price: variant.price,
            compare_at_price: variant.compare_at_price || 0,
            available: variant.available,
            box_count: existing.box_count || 1,
            protein_dates:
              existing.protein_dates != null && existing.protein_dates !== ""
                ? existing.protein_dates
                : null,
            selling_plan_id: firstAllocation
              ? firstAllocation.selling_plan_id
              : firstPlan
                ? firstPlan.id
                : null,
            selling_plan_name: firstPlan ? firstPlan.name : null,
            subscription_price: firstAllocation
              ? firstAllocation.price
              : firstPlan
                ? firstPlan.price
                : variant.price,
            selling_plans: sellingPlans,
          };
        });

        if (selectionMode === "subscribe" && subscribeWrap) {
          applyPurchaseMode("subscribe");
          setActiveOption(subscribeWrap);
        } else if (onetimeButton) {
          applyPurchaseMode("onetime");
          setActiveOption(onetimeButton);
        }

        applySupplyVariant(state.variantId);
        updateOptionPrices();
        updateCartPrice();
      })
      .catch(function () {
        return null;
      });
  }

  function initGallery() {
    if (!mainEl || typeof Swiper === "undefined") {
      return;
    }

    var mainSwiper = null;
    var thumbsSwiper = null;

    try {
      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          spaceBetween: 10,
          slidesPerView: "auto",
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            0: {
              spaceBetween: 8,
            },
            769: {
              spaceBetween: 10,
            },
          },
        });
      }

      mainSwiper = new Swiper(mainEl, {
        spaceBetween: 0,
        speed: 400,
        watchOverflow: true,
        pagination: {
          el: root.querySelector("[data-product-main-pagination]"),
          clickable: true,
        },
        thumbs: thumbsSwiper
          ? {
              swiper: thumbsSwiper,
            }
          : undefined,
      });

      var galleryCounterEl = root.querySelector("[data-product-gallery-counter]");

      function updateGalleryCounter() {
        if (!galleryCounterEl || !mainSwiper) {
          return;
        }

        var current = (mainSwiper.realIndex || 0) + 1;
        var total = mainSwiper.slides ? mainSwiper.slides.length : 0;

        if (!total) {
          return;
        }

        galleryCounterEl.textContent = current + "/" + total;
      }

      updateGalleryCounter();
      mainSwiper.on("slideChange", updateGalleryCounter);

      root.querySelectorAll("[data-product-thumbs-prev]").forEach(function (button) {
        button.addEventListener("click", function () {
          mainSwiper.slidePrev();
        });
      });

      root.querySelectorAll("[data-product-thumbs-next]").forEach(function (button) {
        button.addEventListener("click", function () {
          mainSwiper.slideNext();
        });
      });
    } catch (error) {
      console.error("Product hero swiper init failed:", error);
    }
  }

  function initStickyActions() {
    var actionsEl = root.querySelector("[data-product-actions]");
    var actionsSlotEl = root.querySelector("[data-product-actions-slot]");

    if (!actionsEl || !actionsSlotEl || typeof IntersectionObserver === "undefined") {
      return;
    }

    var mobileMq = window.matchMedia("(max-width: 768px)");
    var observer = null;

    function setStuck(isStuck) {
      if (isStuck) {
        actionsSlotEl.style.height = actionsEl.offsetHeight + "px";
        actionsEl.classList.add("is-stuck");
      } else {
        actionsEl.classList.remove("is-stuck");
        actionsSlotEl.style.height = "";
      }
    }

    function onIntersect(entries) {
      if (!mobileMq.matches) {
        setStuck(false);
        return;
      }

      entries.forEach(function (entry) {
        setStuck(!entry.isIntersecting);
      });
    }

    function bindObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      setStuck(false);

      if (!mobileMq.matches) {
        return;
      }

      observer = new IntersectionObserver(onIntersect, {
        threshold: 0,
        rootMargin: "0px",
      });
      observer.observe(actionsSlotEl);
    }

    bindObserver();

    if (typeof mobileMq.addEventListener === "function") {
      mobileMq.addEventListener("change", bindObserver);
    } else if (typeof mobileMq.addListener === "function") {
      mobileMq.addListener(bindObserver);
    }

    window.addEventListener(
      "resize",
      function () {
        if (actionsEl.classList.contains("is-stuck")) {
          actionsSlotEl.style.height = actionsEl.offsetHeight + "px";
        }
      },
      { passive: true }
    );
  }

  function initDetails() {
    if (!detailsList) {
      return;
    }

    detailsList.addEventListener("click", function (event) {
      var trigger = event.target.closest(".product-hero__details-trigger");

      if (!trigger || !detailsList.contains(trigger)) {
        return;
      }

      var item = trigger.closest(".product-hero__details-item");
      var collapse = item ? item.querySelector(".product-hero__details-collapse") : null;

      if (!item || !collapse) {
        return;
      }

      if (item.classList.contains("product-hero__details-item--expanded")) {
        collapseDetailsItem(item, trigger, collapse);
        return;
      }

      detailsList.querySelectorAll(".product-hero__details-item--expanded").forEach(function (openItem) {
        collapseDetailsItem(
          openItem,
          openItem.querySelector(".product-hero__details-trigger"),
          openItem.querySelector(".product-hero__details-collapse")
        );
      });

      collapse.hidden = false;
      item.classList.add("product-hero__details-item--expanded");
      trigger.setAttribute("aria-expanded", "true");
    });
  }

  function collapseDetailsItem(item, trigger, collapse) {
    if (!item || !trigger || !collapse || !item.classList.contains("product-hero__details-item--expanded")) {
      return;
    }

    item.classList.remove("product-hero__details-item--expanded");
    trigger.setAttribute("aria-expanded", "false");

    collapse.addEventListener("transitionend", function onClose(event) {
      if (event.propertyName !== "grid-template-rows") {
        return;
      }

      if (!item.classList.contains("product-hero__details-item--expanded")) {
        collapse.hidden = true;
      }

      collapse.removeEventListener("transitionend", onClose);
    });
  }

  initGallery();
  initDetails();
  initStickyActions();
  initSubscribeSort();

  if (onetimeButton) {
    onetimeButton.addEventListener("click", function () {
      applyPurchaseMode("onetime");
      setActiveOption(onetimeButton);
      updateCartPrice();
    });
  }

  if (subscribeButton && subscribeWrap) {
    subscribeButton.addEventListener("click", function () {
      if (selectionMode !== "subscribe") {
        applyPurchaseMode("subscribe");
      }

      setActiveOption(subscribeWrap);
      updateCartPrice();
    });
  }

  supplyButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      applySupplyVariant(button.getAttribute("data-variant-id") || "");
    });
  });

  if (minusBtn && plusBtn && qtyEl) {
    minusBtn.addEventListener("click", function () {
      var qty = parseInt(qtyEl.textContent, 10) || 1;
      qty = Math.max(1, qty - 1);
      qtyEl.textContent = String(qty);
      state.qty = qty;
      updateQtyLock();
      updateCartPrice();
    });

    plusBtn.addEventListener("click", function () {
      var qty = parseInt(qtyEl.textContent, 10) || 1;
      qty += 1;
      qtyEl.textContent = String(qty);
      state.qty = qty;
      updateQtyLock();
      updateCartPrice();
    });
  }

  if (cartBtn && root.getAttribute("data-available") === "true") {
    cartBtn.addEventListener("click", function () {
      if (!state.variantId || !state.available) {
        return;
      }

      var body = {
        id: parseInt(state.variantId, 10),
        quantity: parseInt(qtyEl && qtyEl.textContent, 10) || 1,
      };

      if (selectionMode === "subscribe" && state.sellingPlanId) {
        body.selling_plan = parseInt(state.sellingPlanId, 10);
      }

      cartBtn.classList.add("product-hero__cart-btn--loading");
      cartBtn.setAttribute("aria-disabled", "true");

      fetch(shopifyRoot() + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Add to cart failed");
          }

          return response.json();
        })
        .then(function () {
          if (window.CpCartDrawer && typeof window.CpCartDrawer.openAfterAdd === "function") {
            return window.CpCartDrawer.openAfterAdd();
          }

          var openTrigger = document.querySelector("[data-cart-drawer-open]");
          if (openTrigger) {
            openTrigger.click();
            return;
          }

          window.location.href = shopifyRoot() + "cart";
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          cartBtn.classList.remove("product-hero__cart-btn--loading");
          cartBtn.removeAttribute("aria-disabled");
        });
    });
  }

  if (selectionMode === "subscribe" && subscribeWrap) {
    applyPurchaseMode("subscribe");
    setActiveOption(subscribeWrap);
  } else if (onetimeButton) {
    applyPurchaseMode("onetime");
    setActiveOption(onetimeButton);
  }

  if (supplyButtons.length || subscribeWrap || onetimeButton) {
    applySupplyVariant(state.variantId);
    updateOptionPrices();
  }

  updateQtyLock();
  updateCartPrice();
  hydrateFromProductJson();
})();
